import styled from 'styled-components/macro';

export const Container = styled.div`
  > div {
    height: 100%;
  }
`;
